module.exports = __webpack_public_path__ + "static/media/Diesel.c92ffb14.svg";